import { render, staticRenderFns } from "./OpinionMedia.vue?vue&type=template&id=896c20f6&"
import script from "./OpinionMedia.vue?vue&type=script&lang=js&"
export * from "./OpinionMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports